import {Component, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'la-page-title',
  template: `
    <div class="la-page-title">
      <ng-content></ng-content>
    </div>`,
  styles: [`
    .la-page-title{width:100%;height:132px;padding:39px 120px 39px 0;display:flex;align-items:center}.la-page-title la-text{margin-right:auto;margin-left:8px}.la-page-title .la-button,.la-page-title .la-round-button{margin-right:16px;margin-left:0}.la-page-title la-button :last-child{margin-right:0;margin-left:0}.la-page-title la-round-button:last-child{margin-right:0;margin-left:0}.la-page-title .la-spacer{height:44px;width:2px;background:rgba(54,68,79,.05);margin-right:16px;margin-left:0}
  `],
  encapsulation: ViewEncapsulation.None
})
export class LaPageTitleComponent {
}
